// export const apiURL = "https://apis.staffoo.com.au/";
export const apiURL = "https://apis-staging.staffoo.com.au/";
export const STRIPE_PUBLISHABLE_KEY =
  "pk_test_51TBYBwDb535HMVUZHtQiPJGDYYZex0gIGvFWtuKR9FRage5WxqqzkLDvKBUpq4MfPkWhgDDM7z3WZrURpwWFBkbo005rxvV6q9";

export const TIME_KEYS = [
  "metro_mon_to_fri_day_rate",
  "reg_mon_to_fri_day_rate",
  "metro_mon_to_fri_night_rate",
  "reg_mon_to_fri_night_rate",

  "metro_sat_day_rate",
  "reg_sat_day_rate",
  "metro_sat_night_rate",
  "reg_sat_night_rate",

  "metro_sun_day_rate",
  "reg_sun_day_rate",
  "metro_sun_night_rate",
  "reg_sun_night_rate",

  "metro_pub_holi_day_rate",
  "reg_pub_holi_day_rate",
  "metro_pub_holi_night_rate",
  "reg_pub_holi_night_rate",
];

export const SLOT_ROWS = [
  {
    label: "Mon-Fri (Day 06:00 - 18:00)",
    metro: "metro_mon_to_fri_day_rate",
    reg: "reg_mon_to_fri_day_rate",
  },
  {
    label: "Mon-Fri (Night 18:00 - 06:00)",
    metro: "metro_mon_to_fri_night_rate",
    reg: "reg_mon_to_fri_night_rate",
  },
  {
    label: "Saturday (Day)",
    metro: "metro_sat_day_rate",
    reg: "reg_sat_day_rate",
  },
  {
    label: "Saturday (Night)",
    metro: "metro_sat_night_rate",
    reg: "reg_sat_night_rate",
  },
  {
    label: "Sunday (Day)",
    metro: "metro_sun_day_rate",
    reg: "reg_sun_day_rate",
  },
  {
    label: "Sunday (Night)",
    metro: "metro_sun_night_rate",
    reg: "reg_sun_night_rate",
  },
  {
    label: "Public Holiday (Day)",
    metro: "metro_pub_holi_day_rate",
    reg: "reg_pub_holi_day_rate",
  },
  {
    label: "Public Holiday (Night)",
    metro: "metro_pub_holi_night_rate",
    reg: "reg_pub_holi_night_rate",
  },
];

export const COUNTRIES = [
  { code: "AFG", name: "Afghanistan" },
  { code: "ALB", name: "Albania" },
  { code: "DZA", name: "Algeria" },
  { code: "ASM", name: "American Samoa" },
  { code: "AND", name: "Andorra" },
  { code: "AGO", name: "Angola" },
  { code: "AIA", name: "Anguilla" },
  { code: "ATA", name: "Antarctica" },
  { code: "ATG", name: "Antigua and Barbuda" },
  { code: "ARG", name: "Argentina" },
  { code: "ARM", name: "Armenia" },
  { code: "ABW", name: "Aruba" },
  { code: "AUS", name: "Australia" },
  { code: "AUT", name: "Austria" },
  { code: "AZE", name: "Azerbaijan" },
  { code: "BHS", name: "Bahamas" },
  { code: "BHR", name: "Bahrain" },
  { code: "BGD", name: "Bangladesh" },
  { code: "BRB", name: "Barbados" },
  { code: "BLR", name: "Belarus" },
  { code: "BEL", name: "Belgium" },
  { code: "BLZ", name: "Belize" },
  { code: "BEN", name: "Benin" },
  { code: "BMU", name: "Bermuda" },
  { code: "BTN", name: "Bhutan" },
  { code: "BOL", name: "Bolivia" },
  { code: "BIH", name: "Bosnia and Herzegovina" },
  { code: "BWA", name: "Botswana" },
  { code: "BRA", name: "Brazil" },
  { code: "BRN", name: "Brunei" },
  { code: "BGR", name: "Bulgaria" },
  { code: "BFA", name: "Burkina Faso" },
  { code: "BDI", name: "Burundi" },
  { code: "CPV", name: "Cabo Verde" },
  { code: "KHM", name: "Cambodia" },
  { code: "CMR", name: "Cameroon" },
  { code: "CAN", name: "Canada" },
  { code: "CYM", name: "Cayman Islands" },
  { code: "CAF", name: "Central African Republic" },
  { code: "TCD", name: "Chad" },
  { code: "CHL", name: "Chile" },
  { code: "CHN", name: "China" },
  { code: "COL", name: "Colombia" },
  { code: "COM", name: "Comoros" },
  { code: "COG", name: "Congo" },
  { code: "COD", name: "Congo (Democratic Republic)" },
  { code: "CRI", name: "Costa Rica" },
  { code: "CIV", name: "Côte d'Ivoire" },
  { code: "HRV", name: "Croatia" },
  { code: "CUB", name: "Cuba" },
  { code: "CYP", name: "Cyprus" },
  { code: "CZE", name: "Czech Republic" },
  { code: "DNK", name: "Denmark" },
  { code: "DJI", name: "Djibouti" },
  { code: "DMA", name: "Dominica" },
  { code: "DOM", name: "Dominican Republic" },
  { code: "ECU", name: "Ecuador" },
  { code: "EGY", name: "Egypt" },
  { code: "SLV", name: "El Salvador" },
  { code: "GNQ", name: "Equatorial Guinea" },
  { code: "ERI", name: "Eritrea" },
  { code: "EST", name: "Estonia" },
  { code: "SWZ", name: "Eswatini" },
  { code: "ETH", name: "Ethiopia" },
  { code: "FJI", name: "Fiji" },
  { code: "FIN", name: "Finland" },
  { code: "FRA", name: "France" },
  { code: "GAB", name: "Gabon" },
  { code: "GMB", name: "Gambia" },
  { code: "GEO", name: "Georgia" },
  { code: "DEU", name: "Germany" },
  { code: "GHA", name: "Ghana" },
  { code: "GRC", name: "Greece" },
  { code: "GRL", name: "Greenland" },
  { code: "GRD", name: "Grenada" },
  { code: "GUM", name: "Guam" },
  { code: "GTM", name: "Guatemala" },
  { code: "GIN", name: "Guinea" },
  { code: "GNB", name: "Guinea-Bissau" },
  { code: "GUY", name: "Guyana" },
  { code: "HTI", name: "Haiti" },
  { code: "HND", name: "Honduras" },
  { code: "HUN", name: "Hungary" },
  { code: "ISL", name: "Iceland" },
  { code: "IND", name: "India" },
  { code: "IDN", name: "Indonesia" },
  { code: "IRN", name: "Iran" },
  { code: "IRQ", name: "Iraq" },
  { code: "IRL", name: "Ireland" },
  { code: "ISR", name: "Israel" },
  { code: "ITA", name: "Italy" },
  { code: "JAM", name: "Jamaica" },
  { code: "JPN", name: "Japan" },
  { code: "JOR", name: "Jordan" },
  { code: "KAZ", name: "Kazakhstan" },
  { code: "KEN", name: "Kenya" },
  { code: "KIR", name: "Kiribati" },
  { code: "PRK", name: "North Korea" },
  { code: "KOR", name: "South Korea" },
  { code: "KWT", name: "Kuwait" },
  { code: "KGZ", name: "Kyrgyzstan" },
  { code: "LAO", name: "Laos" },
  { code: "LVA", name: "Latvia" },
  { code: "LBN", name: "Lebanon" },
  { code: "LSO", name: "Lesotho" },
  { code: "LBR", name: "Liberia" },
  { code: "LBY", name: "Libya" },
  { code: "LIE", name: "Liechtenstein" },
  { code: "LTU", name: "Lithuania" },
  { code: "LUX", name: "Luxembourg" },
  { code: "MDG", name: "Madagascar" },
  { code: "MWI", name: "Malawi" },
  { code: "MYS", name: "Malaysia" },
  { code: "MDV", name: "Maldives" },
  { code: "MLI", name: "Mali" },
  { code: "MLT", name: "Malta" },
  { code: "MHL", name: "Marshall Islands" },
  { code: "MRT", name: "Mauritania" },
  { code: "MUS", name: "Mauritius" },
  { code: "MEX", name: "Mexico" },
  { code: "FSM", name: "Micronesia" },
  { code: "MDA", name: "Moldova" },
  { code: "MCO", name: "Monaco" },
  { code: "MNG", name: "Mongolia" },
  { code: "MNE", name: "Montenegro" },
  { code: "MAR", name: "Morocco" },
  { code: "MOZ", name: "Mozambique" },
  { code: "MMR", name: "Myanmar" },
  { code: "NAM", name: "Namibia" },
  { code: "NRU", name: "Nauru" },
  { code: "NPL", name: "Nepal" },
  { code: "NLD", name: "Netherlands" },
  { code: "NZL", name: "New Zealand" },
  { code: "NIC", name: "Nicaragua" },
  { code: "NER", name: "Niger" },
  { code: "NGA", name: "Nigeria" },
  { code: "MKD", name: "North Macedonia" },
  { code: "NOR", name: "Norway" },
  { code: "OMN", name: "Oman" },
  { code: "PAK", name: "Pakistan" },
  { code: "PLW", name: "Palau" },
  { code: "PSE", name: "Palestine" },
  { code: "PAN", name: "Panama" },
  { code: "PNG", name: "Papua New Guinea" },
  { code: "PRY", name: "Paraguay" },
  { code: "PER", name: "Peru" },
  { code: "PHL", name: "Philippines" },
  { code: "POL", name: "Poland" },
  { code: "PRT", name: "Portugal" },
  { code: "PRI", name: "Puerto Rico" },
  { code: "QAT", name: "Qatar" },
  { code: "ROU", name: "Romania" },
  { code: "RUS", name: "Russia" },
  { code: "RWA", name: "Rwanda" },
  { code: "WSM", name: "Samoa" },
  { code: "SMR", name: "San Marino" },
  { code: "STP", name: "São Tomé and Príncipe" },
  { code: "SAU", name: "Saudi Arabia" },
  { code: "SEN", name: "Senegal" },
  { code: "SRB", name: "Serbia" },
  { code: "SYC", name: "Seychelles" },
  { code: "SLE", name: "Sierra Leone" },
  { code: "SGP", name: "Singapore" },
  { code: "SVK", name: "Slovakia" },
  { code: "SVN", name: "Slovenia" },
  { code: "SLB", name: "Solomon Islands" },
  { code: "SOM", name: "Somalia" },
  { code: "ZAF", name: "South Africa" },
  { code: "SSD", name: "South Sudan" },
  { code: "ESP", name: "Spain" },
  { code: "LKA", name: "Sri Lanka" },
  { code: "SDN", name: "Sudan" },
  { code: "SUR", name: "Suriname" },
  { code: "SWE", name: "Sweden" },
  { code: "CHE", name: "Switzerland" },
  { code: "SYR", name: "Syria" },
  { code: "TWN", name: "Taiwan" },
  { code: "TJK", name: "Tajikistan" },
  { code: "TZA", name: "Tanzania" },
  { code: "THA", name: "Thailand" },
  { code: "TLS", name: "Timor-Leste" },
  { code: "TGO", name: "Togo" },
  { code: "TON", name: "Tonga" },
  { code: "TTO", name: "Trinidad and Tobago" },
  { code: "TUN", name: "Tunisia" },
  { code: "TUR", name: "Turkey" },
  { code: "TKM", name: "Turkmenistan" },
  { code: "TUV", name: "Tuvalu" },
  { code: "UGA", name: "Uganda" },
  { code: "UKR", name: "Ukraine" },
  { code: "ARE", name: "United Arab Emirates" },
  { code: "GBR", name: "United Kingdom" },
  { code: "USA", name: "United States" },
  { code: "URY", name: "Uruguay" },
  { code: "UZB", name: "Uzbekistan" },
  { code: "VUT", name: "Vanuatu" },
  { code: "VAT", name: "Vatican City" },
  { code: "VEN", name: "Venezuela" },
  { code: "VNM", name: "Vietnam" },
  { code: "YEM", name: "Yemen" },
  { code: "ZMB", name: "Zambia" },
  { code: "ZWE", name: "Zimbabwe" },
];
